
import React, { useState } from 'react'
import cardImg from "../assets/images/cardImg.svg";
import FileSaveOff from "../assets/images/FileSaveOff.svg";
import Checklist from "../assets/images/Checklist.svg";
import blue_email from "../assets/images/blue_email.svg";
import hourglassIcon from "../assets/images/Hourglass.svg";
import ShieldQuestion from "../assets/images/ShieldQuestion.svg";
import AccessTime from "../assets/images/AccessTime.svg";
import nextplan from "../assets/images/nextplan.svg";
import { useNavigate } from 'react-router-dom';
import LogOutIcon from "../assets/images/LogOutNew.svg";
import BackIcon from "../assets/images/ArrowBackBlue.svg";
import editProfileIcon from "../assets/images/editProfileBlue.svg";
import CheckCircleActvIcon from "../assets/images/checkGreen.svg";
import { useSelector } from 'react-redux';


export default function LywoApplication3() {
  const navigate = useNavigate();

  const state = useSelector(state => state.roundData)

  const currentStep = 3;

  const getProgressWidth = () => {
    if (currentStep === 1) return '33%';
    if (currentStep === 2) return '66%';
    if (currentStep === 3) return '100%';
  };

  return (
    <>
      <div className="paGeWrap m-botm">
        <div className="paGeWrap-pdg">
          <div className='container colCntR'>
            <h3>Dear {state?.userName}</h3>
            <h4>Your Application Is Now Complete</h4>
            <div className="col-12 col-md-10 col-lg-8 emailNotifiTxt mobBgWrap">
              <p>
                <img src={blue_email} className="blueEmailIcon mb-1" />
                We will send you an update on <span className="eMailaDrs">{state?.userEmail}</span>
              </p>
            </div>
            <div className='col-12 col-md-10 col-lg-8 mobBgWrap1'>
              <div className='progressbarWrap'>
                <div className="progressBarContainer">
                  <div className="progressFill" style={{ width: getProgressWidth() }}>
                  </div>
                  {/* <div className="progressDots">
                  <div className="dummyDot"></div>
                  <div className="dummyDot"></div>
                  <div className="dummyDot"></div>
                  <div className={`${currentStep === 3}`}></div>
                </div> */}
                </div>
                <div className="mileStoneTxt">
                  <div><p></p></div>
                  <div className='milstnTxtImg'><img src={CheckCircleActvIcon} className="checkIcon" /><p className='mileStoneActv'>Preliminary info</p></div>
                  <div className='milstnTxtImg'><img src={CheckCircleActvIcon} className="checkIcon" /><p className='mileStoneActv'>Behavior</p></div>
                  <div className='milstnTxtImg'><img src={CheckCircleActvIcon} className="checkIcon" /><p className='mileStoneActv'>MCQ</p></div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-10 col-lg-8'>
              <div className='behavr-box-wrap'>
                <div className='clbrtn-box'>
                  <img src={hourglassIcon} className="clbrtnIcon" alt="" />
                  <h5>Thank You for Applying</h5>
                </div>
                <div className='ARW-sec-flshScrn' style={{ borderRadius: "16px", paddingTop: '16px' }}>
                  <h2 className='next-step-lywo' style={{ fontSize: "16px", marginBottom: "0px" }}>What happens next ?</h2>

                  <div className="instrctnBox">

                    <div className='instrctnList'>
                      <div className='instrctnNumWrap'>1</div>
                      <p>Your responses will be carefully reviewed by the hiring team.</p>
                    </div>
                    <div className='instrctnList'>
                      <div className='instrctnNumWrap'>2</div>
                      <p>You'll receive an email with the next steps soon.</p>
                    </div>
                    <div className='instrctnList'>
                      <div className='instrctnNumWrap'>3</div>
                      <p>Please follow the instructions shared in that email.</p>
                    </div>
                    <div className='instrctnList'>
                      <div className='instrctnNumWrap'>4</div>
                      <p>If you have any questions, simply reply to the same email.</p>
                    </div>

                  </div>
                </div>

                <div className='clbrtn-box-mob'>
                  <img src={hourglassIcon} className="clbrtnIcon" alt="" />
                  <h5>Thank You for Applying</h5>
                </div>
                <div className='neWbTnAreaWrap'>
                  <div className="btnLywo1" onClick={() => navigate("/Lywocode")}>
                    <p>Exit</p>
                    <img src={LogOutIcon} className="mobIcon" alt="About Company" />
                  </div>
                </div>
              </div>
            </div >
          </div >
        </div>

        <div className="mobile-icons" >
          <div></div>
          <div className="mobile-icon-txt" onClick={() =>
            // navigate("/JobApplicationProcess")
            navigate("/JobApplicationProcess", { state: { fromOtherPage: true } })
          }>
            <img src={editProfileIcon} className="mobIcon" alt="Edit Profile" />
            <p>Edit Profile</p>
          </div>
          <div></div>
        </div>
      </div >
    </>

  )
}
